import { Button, Flex, Heading, Icon, Container } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IoMdCloseCircle } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';

import { routePaths } from 'global/routePaths';

const DeclinedShift = () => {
  const navigate = useNavigate();

  const { t } = useTranslation(['common', 'scheduling']);

  return (
    <Container w="full" h="full" centerContent>
      <Flex
        px={{ base: 4, md: 8, lg: 16 }}
        py={{ base: 6, md: 8, lg: 12 }}
        mt="10"
        bg="white"
        h="full"
        w="full"
        alignItems="center"
        justifyContent="center"
        flexDir="column"
        boxShadow="rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
      >
        <Icon as={IoMdCloseCircle} w="100px" h="100px" mb="5" color="secondary.700" />
        <Heading as="h3" fontSize="3xl" color="secondary.700" mb="2">
          {t('scheduling:shiftDeclined')}
        </Heading>
        <Button w="half" mt="4" onClick={() => navigate(routePaths.home)}>
          {t('common:goHome')}
        </Button>
      </Flex>
    </Container>
  );
};

export default DeclinedShift;
